<script setup>
import { Link } from '@inertiajs/vue3';
defineProps({
  links: Array,
})

// page=1 — это и есть базовая страница. Не линкуем ?page=1 (это дубль
// канонического URL): убираем параметр, чтобы кнопка «1» вела на чистый адрес.
const cleanUrl = (url) => {
  if (!url) return url;
  try {
    const u = new URL(url, 'https://nedicom.ru');
    if (u.searchParams.get('page') === '1') u.searchParams.delete('page');
    const qs = u.searchParams.toString();
    return u.origin + u.pathname + (qs ? '?' + qs : '');
  } catch {
    return url;
  }
};
</script>

<template>
  <div class="flex justify-center py-3 my-3">
    <div class="flex justify-between border-gray-200 rounded-lg">
      <!-- Цели нажатия были 18 px в ширину и стояли вплотную (-space-x-px):
           попасть пальцем в нужную страницу можно было только с прицелом.
           Теперь минимум 44×44 и просвет между ними — как требует Google.
           aria-current стоял на КАЖДОЙ ссылке, то есть озвучка сообщала
           «текущая страница» про все сразу; теперь только на активной. -->
      <nav class="isolate inline-flex items-center gap-1" aria-label="Постраничная навигация">
        <template v-for="(link, k) in links" :key="k">
          <Link v-if="link.url" :href="cleanUrl(link.url)"
            :class="{ 'text-indigo-700 font-extrabold bg-gray-100': link.active, 'font-normal': !link.active}"
            :aria-current="link.active ? 'page' : undefined"
            class="relative z-10 inline-flex items-center justify-center min-w-[44px] min-h-[44px] px-3 md:px-4 text-sm font-medium text-indigo-600 focus:z-20 hover:bg-gray-200 rounded-full"><span v-html="link.label" /></Link>
          <span v-else v-html="link.label"
            :class="{ 'text-indigo-700 font-extrabold bg-gray-100': link.active, 'font-normal': !link.active}"
            class="relative inline-flex items-center justify-center min-w-[44px] min-h-[44px] px-3 md:px-4 text-sm font-medium text-gray-500 cursor-default rounded-full" />
        </template>
      </nav>

    </div>
  </div>
</template>